//chapter1
export default {
    id : 1,//chapter number
    title : '01. FMEA 개요 (1) - FMEA와 품질 만들기',//chapter name
    slides : [
        {
            title : '역량 체크리스트',
            type : 'pre-test',
            checkList : [
                {
                    page : 1,
                    body : [
                        '<strong>1.</strong> 나는 제품개발 업무를 담당하거나 개발 프로젝트를 경험해 본 적이 있다.',
                        '<strong>2.</strong> 나는 제품 및 공정 개발 업무에서 발생 가능한 품질 문제를 해결하기 위한 노력을 한다.',
                        '<strong>3.</strong> 나는 품질 문제 해결을 위한 실제 업무를 하고 있다.',
                        '<strong>4.</strong> 나는 프로토 관리 계획을 작성하거나 업무에서 사용한다.',
                        '<strong>5.</strong> 나는 양산 관리 계획을 작성할 수 있다.',
                        '<strong>6.</strong> 나는 양산 관리 계획을 업무에서 사용한다.',
                        '<strong>7.</strong> 나는 제품 및 공정개발 과정에서 관리 계획을 작성하는 업무 절차를 알고 있다.',
                        '<strong>8.</strong> 나는 관리 계획을 작성하기 위해 FMEA를 업무에 적용하고 있다.',
                        '<strong>9.</strong> 내가 작성한 FMEA의 결과는 제품 설계와 공정 개발을 하는데 도움이 된다.',
                        '<strong>10.</strong> 나는 AIAG-VDA FMEA에 대한 지식이 있다.',
                    ]
                },
                {
                    page : 2,
                    body : [
                        '<strong>11.</strong> 나는 실제 업무에 AIAG-VDA FMEA를 적용해 본 적이 있다.',
                        '<strong>12.</strong> 나는 DFMEA와 PFMEA를 연결하는 방법을 알고 있다.',
                        '<strong>13.</strong> 나는 FMEA를 작성하는데 고장을 특성으로 표현할 수 있다.',
                        '<strong>14.</strong> 나는 Block- Boundry Diagram을 이용하여 구조분석이 가능하다.',
                        '<strong>15.</strong> 나는 제품설계를 위한 Parameter Daigram을 작성할 수 있다.',
                        '<strong>16.</strong> 나는 제품에서 고장영향, 고장형태, 고장원인을 구별하고 연결하여 작성할 수 있다.',
                        '<strong>17.</strong> 나는 설계관리의 개념을 알고 적용할 수 있다.',
                        '<strong>18.</strong> 나는 RISK의 개념을 알고 AP 평가를 할 수 있다.',
                        '<strong>19.</strong> 나는 설계 검증과 설계 유효성 확인의 개념을 구분하여 활용할 수 있다.',
                        '<strong>20.</strong> 나는 특성 매트릭스를 작성할 수 있다.',
                    ]
                },
                {
                    page : 3,
                    body : [
                        '<strong>21.</strong> 나는 공정흐름도를 작성할 수 있다.',
                        '<strong>22.</strong> 나는 공정개발을 위한 Parameter Diagram을 작성할 수 있다.',
                        '<strong>23.</strong> 나는 PFMEA와 관리계획서를 연계하는 방법을 적용할 수 있다.',
                        '<strong>24.</strong> 나는 공정에서의 고장형태, 고장영향, 고장원인의 구조를 이해하고 적용할 수 있다.',
                        '<strong>25.</strong> 나는 공정관리 방안에 대해 개념을 알고 적용할 수 있다.',
                        '<strong>26.</strong> 나는 품질 표준문서의 정합성을 갖추기 위한 업무를 추진할 수 있다.',
                        '<strong>27.</strong> 나는 품질표준 문서 DB화를 적용할 수 있다.',
                        '<strong>28.</strong> 나는 Living Document로서의 FMEA의 기능을 이해하고 적용할 수 있다.',
                        '<strong>29.</strong> 나는 APQP 프로세스와 FMEA의 작성절차를 연계하여 작성할 수 있다.',
                        '<strong>30.</strong> 나는 FTA와 FMEA를 구분하여 설명할 수 있다.',
                    ]
                },
            ],
            result : {
                level1 : {
                    body : '<h3>[관리계획서와 FMEA]</h3><li>품질과 관리계획</li><li>FMEA와 관리계획</li><li>관리계획 이해</li><li>PFMEA 이해</li>',
                    title : "초급 보충자료",
                    file : "./files/01.zip",
                },
                level2 : {
                    body : '<h3>[APQP와 FMEA]</h3><li>제품개발과 FMEA 이해</li><li>개발기획과 요건</li><li>제품개발과 요건</li><li>공정개발과 요건</li><li>유효성 확인과 요건</li>',
                    title : "중급 보충자료",
                    file : "./files/02.zip",
                },
                level3 : {
                    body : '<h3>[모니터링 및 시스템 응답 FMEA]</h3><li>FMEA-MSR 1단계 : 기획 및 준비</li><li>FMEA-MSR 2단계 : 구조 분석</li><li>FMEA-MSR 3단계 : 기능 분석</li><li>FMEA-MSR 4단계 : 고장 분석</li><li>FMEA-MSR 5단계 : 리스크 분석</li><li>FMEA-MSR 6단계 : 최적화</li><li>FMEA-MSR 7단계 : 결과 문서화</li>',
                    title : "고급 보충자료",
                    file : "./files/03.zip",
                },
            },
            bgm : "checkbgm.mp3",
            // quizMask : "../assets/images/bono_quiz_mask.jpg",//quiz mask
        },
        {
            title : 'Intro',
            type : 'intro',
            source : 'c01.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'FMEA와 품질 만들기',
            ],
            body2 : [
                'FMEA와 품질 만들기에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : '01.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '자주관리 상태는 품질문제를 해결할 수 있다.',//html available
                    answer : "2",
                    explain : '자주관리 상태는 작업자가 관리할 수 있는 환경을 만드는 것이다.'
                },
                {
                    type : 'ox',
                    question : '개발과정에서 품질표준을 만든다.',//html available
                    answer : "1",
                    explain : '개발과정의 결과는 품질표준이다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 품질문제는 왜 발생하는가를 제시</h3>
                        <p classs="mg10"></p>
                        <h3>2. 품질문제 관리를 위한 품질 원칙설명</h3>
                        <li>예방, 검출, 시정의 이해</li>
                        <p class="mg10"></p>
                        <h3>3. 개발과정에서 품질만들기의 절차</h3>
                        <li>과거문제와 RISK 평가</li>
                        <li>관리표준으로 관리계획 만들기</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c01.mp4',
        },
    ]
}